import fetchAPI from '../utils/fetchAPI';

export default ({ xsrfToken, sellerId }: { xsrfToken: string; sellerId: number }) =>
  fetchAPI({
    method: 'DELETE',
    url: `/smb-profile/api/favoritesellers/${sellerId}`,
    xsrfToken,
  });
